var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CD00FF;}\r\n\t.st1{fill:#00A4FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.05,669.28l-0.03,0.03L380.48,549.77l-2.33-2.33l-60.33,60.32l2.33,2.33L439.67,729.6 c33.33,33.33,87.37,33.33,120.7,0l0,0L500.05,669.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M729.78,560.19L729.78,560.19c33.33-33.32,33.33-87.35,0-120.68l-168.9-168.9 c-33.61-33.61-88.11-33.61-121.72,0L270.2,439.57c-33.29,33.29-33.29,87.27,0,120.56l0,0l30.16-30.16l0.04,0.04l84.73-84.73 l198.05,198.05l0.1-0.11l31.73,31.73l60.28-60.28l-60.32-60.33l-0.06,0.06L445.45,384.96l54.56-54.56l169.45,169.45l-0.02,0.01 L729.78,560.19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiFarm);
export default __webpack_public_path__ + "static/media/MultiFarm.7a448b2d9cfe14dfca88e1a85d77e2e6.svg";
export { ForwardRef as ReactComponent };